export default {
  distributeProductList: '/course/supply/distributor/product/page', //分销商品列表
  distributeProductExport: '/course/supply/distributor/product/export',
  distributeProductStatusUpdate: '/course/supply/distributor/product/distribution/flag/edit',
  distributeRecordList: '/order/identify/agent/query/order/all', // 分销记录列表
  distributeRecordExport: '/order/identify/agent/query/order/all/export',
}
